module.exports = __webpack_public_path__ + "static/media/14UNEP3.12246919.jpg";